export default "__VITE_ASSET__4oGjZTFY__"